export enum ClinicalActivityDue {
  Date = "date",
  Consult = "consult"
}
